// extracted by mini-css-extract-plugin
module.exports = {"list":"Items_list__1zlOe","card":"Items_card__38xi1","loader":"Items_loader__3LfIG"};